import { render, staticRenderFns } from "./LapSaldoAwal.vue?vue&type=template&id=13ca6c2c"
import script from "./LapSaldoAwal.vue?vue&type=script&lang=js"
export * from "./LapSaldoAwal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports